import { Component } from "@angular/core";

@Component({
    selector: 'vt-welcome',
    templateUrl: './welcome.component.html'
})

export class WelcomeComponent {
}
